// extracted by mini-css-extract-plugin
module.exports =  {"tag":"TagBeta-module__tag___eFoIq"};